import { useEffect, useState, useContext } from 'react'
import { runInAction } from 'mobx' // Ajouter cet import
import { MaterialReactTable } from 'material-react-table'
import { MRT_Localization_FR } from 'material-react-table/locales/fr'
import { Box, Button, TablePagination } from '@mui/material'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import {
  collectFormAnswersData,
  deleteFormResponses,
  downloadFile,
} from '../../services/api'
import { BuilderContext } from '../Sandbox/components/store/store.Builder'
import { observer } from 'mobx-react-lite'
import styles from './Answers.module.css'
import { utils, writeFile } from 'xlsx'

import { Spin } from 'antd'
import { Modal, Tooltip, Popconfirm } from 'antd'
import {
  WebSocketListener,
  sendMessage,
} from '../Sandbox/components/webSocket/WebSocketListener'

import { toJS } from 'mobx'
import { ViewFormContext } from '../ViewForm/components/store/store.ViewForm'
import RenderForm from '../../components/RenderForm/RenderForm'
import { minHeight } from '@xstyled/styled-components'
import { SvgCloseIcon } from '../../components/svg/SvgComponents'
import { EditOutlined, FileOutlined } from '@ant-design/icons'

import Header from '../../components/Header/Header'
import { nanoid } from 'nanoid'
import { StyleSharp } from '@mui/icons-material'

const Answers = observer(() => {
  const builderContext = useContext(BuilderContext)
  const viewFormContext = useContext(ViewFormContext)

  // Ceci est l'identifiant qui représente la colonne id d'une réponse dans le django
  const IdentifiantForIDDjango = 'header_b0755b90-cc68-42ac-92c6-d165966e1cc9'
  const IdentifiantForCanEditDjango = 'canEdit'

  const [isIDEditing, setIsIDEditing] = useState()

  const [isLoadingData, setIsLoadingData] = useState(false)

  const [currentPage, setCurrentPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(builderContext.pageSize) // Nouvel état pour le nombre d'éléments par page

  const isCollaborativeMode =
    builderContext.styleForm?.is_collaborative_mode === true

  const isDate = (value) => {
    const datePattern1 = /^\d{2}-\d{2}-\d{4}$/ // Vérifie le format DD-MM-YYYY
    const datePattern2 = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}$/ // Vérifie le format DD-MM-YYYY hh:mm
    return datePattern1.test(value) || datePattern2.test(value)
  }

  const handleDownload = (path) => {
    downloadFile(path).catch((error) => {
      console.error('Erreur lors du téléchargement:', error)
    })
  }

  const columns =
    builderContext.collectGetAnswerForm?.results?.headers?.map(
      (header, index) => {
        // Création de l'objet colonne de base
        let column = {
          accessorKey: header.idCanvas,
          type: header.type || '',
          size: header.label.length * 3.8,
          header: header.label,
          enableClickToCopy: true,
          className: styles.headerCentered,
          sortingFn: (rowA, rowB, columnId) => {
            try {
              const valA = rowA._valuesCache[columnId]
              const valB = rowB._valuesCache[columnId]

              if (isDate(valA) && isDate(valB)) {
                console.log('Tri sur une date') // Affichage pour le tri de date
                return (
                  new Date(
                    valA.split(' ')[0].split('-').reverse().join('-') +
                      (valA.includes(':') ? ' ' + valA.split(' ')[1] : '')
                  ).getTime() -
                  new Date(
                    valB.split(' ')[0].split('-').reverse().join('-') +
                      (valB.includes(':') ? ' ' + valB.split(' ')[1] : '')
                  ).getTime()
                )
              } else {
                console.log('Tri alphanumérique') // Affichage pour le tri alphanumérique
                const strA = String(valA)
                const strB = String(valB)
                return strA.localeCompare(strB) // Tri alphanumérique
              }
            } catch (error) {
              console.error('Erreur lors du tri:', error)
              return 0 // ou toute autre logique de sauvegarde que vous souhaitez implémenter
            }
          },
          muiTableHeadCellProps: {
            align: 'center',
          },
          muiTableBodyCellProps: {
            align: 'center',
          },
        }

        // Si le type est "Upload", alors ajouter la propriété Cell
        if (header.type === 'Upload') {
          column.Cell = ({ row }) => {
            const value = row._valuesCache[column.accessorKey]
            if (value && value !== '' && value !== 'Null' && value !== 'null') {
              return (
                <div
                  className={styles.download_button_file}
                  onClick={() => handleDownload(value)}
                >
                  <FileOutlined />
                  Document
                </div>
              )
            }
            return null
          }
        }

        return column
      }
    ) || []

  const csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    headers: columns.map((c) => c.header),
  }

  // const csvExporter = new ExportToCsv(csvOptions)

  // Gérer le changement de page
  const handlePageChange = async (event, newPage) => {
    setCurrentPage(newPage) // Mettre à jour l'état de la page courante
    // Appeler les fonctions nécessaires depuis builderContext pour gérer la pagination
    try {
      builderContext.setCurrentPage(newPage) // Mettre à jour la page courante dans builderContext
      await builderContext.initialisationGETCollectFormAnswersData()
      console.log('Données de pagination chargées avec succès.')
    } catch (error) {
      console.error('Erreur lors de la pagination : ', error)
    }
  }

  // Nouvelle fonction pour gérer le changement du nombre d'éléments par page
  const handleRowsPerPageChange = async (event) => {
    setRowsPerPage(parseInt(event.target.value, 10)) // Mettre à jour le nombre d'éléments par page
    try {
      builderContext.setCurrentPage(0) // Mettre à jour la page courante dans builderContext
      builderContext.setpageSize(event.target.value) // Mettre à jour la page courante dans builderContext
      await builderContext.initialisationGETCollectFormAnswersData()
      console.log('Données de pagination chargées avec succès.')
    } catch (error) {
      console.error('Erreur lors de la pagination : ', error)
    }

    setCurrentPage(0) // Réinitialiser la page courante à 0 lorsque le nombre d'éléments par page change
  }

  let data = builderContext.collectGetAnswerForm.results?.rows || [] // Utiliser le bon chemin d'accès pour accéder aux données 'rows'

  const mapDataForExport = (rows) => {
    return rows.map((row) => {
      let newRow = {}
      columns.forEach((col) => {
        console.log(
          'col.accessorKey:',
          col.accessorKey,
          'Value:',
          row.original[col.accessorKey],
          'Row',
          row.original
        )
        newRow[col.header] = row.original[col.accessorKey]
      })
      return newRow
    })
  }

  const handleExportRows = (rows) => {
    // console.log('Original rows:', rows)
    // const mappedRows = mapDataForExport(rows)
    // console.log('Data to be exported:', mappedRows)
    // csvExporter.generateCsv(mappedRows)
  }

  const handleExportData = async () => {
    try {
      // Récupérez toutes les données depuis l'API pour l'export CSV
      const fullData = await collectFormAnswersData(
        builderContext.url_code,
        1,
        10,
        true
      )

      const mappedData = fullData.rows.map((row) => {
        let newRow = {}
        columns.forEach((col) => {
          newRow[col.header] = row[col.accessorKey]
        })
        return newRow
      })

      console.log('Mapped data for CSV export:', mappedData)
      // csvExporter.generateCsv(mappedData)
    } catch (error) {
      console.error('Error fetching data for CSV export:', error)
      // Gérer l'erreur comme vous le souhaitez, par exemple en affichant une notification à l'utilisateur.
    }
  }

  const handleAddNewResponse = async (rowData) => {
    setIsLoadingData(true)
    viewFormContext.toggleModalAddNewResponseOpen(true)

    const formData = {
      form__url_code: builderContext.url_code,
      // websocketID: ... // Inclure ceci si nécessaire
    }

    const checkPermission = async () => {
      await viewFormContext.initialisationGET(false, rowData)
      console.log('formInformations', toJS(viewFormContext.formInformations))
      console.log('fields', toJS(viewFormContext.fields))
      setIsLoadingData(false)
    }
    checkPermission()
    setIsIDEditing(rowData)
  }

  const handleEditClick = async (rowData) => {
    console.log('editing row id : ', toJS(rowData))
    setIsLoadingData(true)
    viewFormContext.toggleModalVisibilityUpdateOpen(true)
    const formData = {
      form__url_code: builderContext.url_code,
      response__id: rowData,
      // websocketID: ... // Inclure ceci si nécessaire
    }

    const checkPermission = async () => {
      await viewFormContext.initialisationGET(true, rowData)
      console.log('formInformations', toJS(viewFormContext.formInformations))
      console.log('fields', toJS(viewFormContext.fields))
      setIsLoadingData(false)
    }
    checkPermission()
    setIsIDEditing(rowData)

    console.log('rowData', toJS(formData))
    console.log('Editing', toJS(rowData))
  }

  const handleDeleteClick = async (rowData) => {
    console.log(`Deleting`, rowData)

    try {
      await deleteFormResponses(rowData)
      // par exemple, recharger les données ou informer l'utilisateur de la réussite.
    } catch (error) {
      console.error('Erreur lors de la suppression :', error)
    }
  }
  return (
    <div className={styles.page}>
      <Header isAnswersResponse={true} />

      <div className={styles.container}>
        <WebSocketListener />
        <div className={styles.title_page}>
          <div className={styles.title}>
            Réponses pour le formulaire : {builderContext.styleForm.title_form}
          </div>
          <div className={styles.add_new_row}>
            <button
              onClick={handleAddNewResponse}
              className={styles.createButton}
            >
              Ajouter une nouvelle réponse
            </button>
          </div>
        </div>

        <div className={styles.container__table}>
          <MaterialReactTable
            className={`${styles.test} my-mui-table`}
            key={nanoid()}
            columns={columns}
            data={data} // Utiliser les données paginées
            enableRowSelection
            enableStickyHeader
            enablePinning
            positionActionsColumn="last"
            enableRowActions={
              builderContext.styleForm?.is_collaborative_mode === true
            }
            renderRowActions={
              builderContext.styleForm?.is_collaborative_mode === true
                ? ({ row, table }) =>
                    row.original[IdentifiantForCanEditDjango] === true ? (
                      <Box
                        sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}
                      >
                        <Tooltip
                          title={'Modifier'}
                          placement="bottom"
                          color="black"
                          key={'Modifier'}
                        >
                          <Button
                            className={styles.btn_dell_options}
                            onClick={() =>
                              handleEditClick(
                                row.original[IdentifiantForIDDjango]
                              )
                            }
                          >
                            <EditOutlined />
                          </Button>
                        </Tooltip>

                        <Tooltip
                          title={'Supprimer'}
                          placement="bottom"
                          color="black"
                          key={'Supprimer'}
                        >
                          <Popconfirm
                            title="Êtes-vous sûr de vouloir supprimer cet élément?"
                            onConfirm={() =>
                              handleDeleteClick(
                                row.original[IdentifiantForIDDjango]
                              )
                            }
                            okText="Oui"
                            cancelText="Non"
                          >
                            <Button className={styles.btn_dell_options}>
                              <SvgCloseIcon />
                            </Button>
                          </Popconfirm>
                        </Tooltip>
                      </Box>
                    ) : null
                : null
            }
            displayColumnDefOptions={{
              'mrt-row-select': {
                muiTableHeadCellProps: {
                  align: 'center',
                },
                muiTableBodyCellProps: {
                  align: 'center',
                },
              },
              'mrt-row-actions': {
                muiTableHeadCellProps: {
                  align: 'center',
                },
                muiTableBodyCellProps: {
                  align: 'center',
                },
              },
            }}
            defaultColumn={{
              minSize: 100,
              maxSize: 9001,
            }}
            initialState={{
              columnPinning: {
                left: ['mrt-row-select'],
                right: ['mrt-row-actions'],
              },
            }}
            muiTableProps={{
              sx: {
                border: '1px solid rgba(224, 224, 224);',
              },
            }}
            muiTableHeadCellProps={{
              sx: {
                border: '1px solid rgba(224, 224, 224);',
              },
            }}
            muiTableBodyCellProps={{
              sx: {
                border: '1px solid rgba(224, 224, 224);',
              },
            }}
            localization={MRT_Localization_FR}
            positionToolbarAlertBanner="bottom"
            pageIndex={currentPage} // Passer la page courante en tant que prop
            enablePagination={false}
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: 'flex',
                  gap: '1rem',
                  p: '0.5rem',
                  flexWrap: 'wrap',
                }}
              >
                <Button
                  className={styles.buttons}
                  color="primary"
                  onClick={handleExportData}
                  startIcon={<FileDownloadIcon />}
                  variant="contained"
                >
                  Exporter toutes les données
                </Button>

                <Button
                  className={styles.buttons}
                  disabled={table.getRowModel().rows.length === 0}
                  onClick={() => handleExportRows(table.getRowModel().rows)}
                  startIcon={<FileDownloadIcon />}
                  variant="contained"
                >
                  Exporter les lignes de la page
                </Button>

                <Button
                  className={styles.buttons}
                  disabled={
                    !table.getIsSomeRowsSelected() &&
                    !table.getIsAllRowsSelected()
                  }
                  onClick={() =>
                    handleExportRows(table.getSelectedRowModel().rows)
                  }
                  startIcon={<FileDownloadIcon />}
                  variant="contained"
                >
                  Exporter les lignes sélectionnées
                </Button>
              </Box>
            )}
          />

          <TablePagination
            component="div"
            count={builderContext.collectGetAnswerForm?.count || 0}
            page={currentPage}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage} // Utiliser l'état rowsPerPage
            rowsPerPageOptions={[5, 10, 20, 50, 100]} // Options de fonction mises à jour
            labelRowsPerPage="Éléments par page :"
            labelDisplayedRows={({ from, to, count }) =>
              `Affichage des lignes ${from} à ${to} sur ${count}`
            }
            onRowsPerPageChange={handleRowsPerPageChange} // Gérer le changement du nombre d'éléments par page
          />

          <Modal
            title="Modifier les données"
            open={viewFormContext.modalVisibilityUpdateOpen}
            centered
            className={styles.modalUpdated}
            onCancel={() =>
              viewFormContext.toggleModalVisibilityUpdateOpen(false)
            }
            footer={null}
          >
            <div className={styles.modal_body}>
              {isLoadingData ? (
                <div className={styles.spin_div}>
                  <Spin size="large" />
                </div>
              ) : (
                <RenderForm
                  key={isIDEditing}
                  DataForm={viewFormContext.formInformations}
                  DataFields={viewFormContext.fields}
                  isUpdateSubmit={true}
                  isActiveSubmit={true}
                  editingFieldId={isIDEditing}
                  urlCode={viewFormContext.url_code}
                />
              )}
            </div>
          </Modal>

          <Modal
            title="Ajouter une nouvelle réponse"
            open={viewFormContext.modalAddNewResponseOpen}
            centered
            className={styles.modalUpdated}
            onCancel={() =>
              viewFormContext.toggleModalAddNewResponseOpen(false)
            }
            footer={null}
          >
            <div className={styles.modal_body}>
              {isLoadingData ? (
                <div className={styles.spin_div}>
                  <Spin size="large" />
                </div>
              ) : (
                <RenderForm
                  key={nanoid()}
                  DataForm={viewFormContext.formInformations}
                  DataFields={viewFormContext.fields}
                  isUpdateSubmit={false}
                  isActiveSubmit={true}
                  isModalAddNewResponse={true}
                  urlCode={viewFormContext.url_code}
                />
              )}
            </div>
          </Modal>
        </div>
      </div>
    </div>
  )
})

export default Answers
